import { Skeleton } from "antd";
import React from "react";
import rightArrowIcon from "../../assets/icon/rightArrowIcon.svg";
import { getTestInst } from "../../helper/quesInstData";
import { objectValidation } from "../../helper/validation";
import { LaunchTestContext } from "../../store/launchTestStore";
import "./testInstruction.scss";

export default function TestInstruction({
  launchTestData,
  handleBtn1,
  handleBtn2,
  btnName1,
  btnName2,
}) {
  const questions =
    objectValidation(launchTestData) &&
    launchTestData.data &&
    launchTestData.data[0];
  const { launchTestC } = LaunchTestContext();
  const { loader } = launchTestC;
  return (
    <div className="test-instruction">
      <div className="test-instruction-blk">
        {loader ? (
          <Skeleton className="inst-header-skeleton" active />
        ) : (
          <>
            <h1 className="test-name">
              {objectValidation(launchTestData) &&
                launchTestData.data[0].section_name}
            </h1>
            <h1 className="test-instruction-title">How to take this Test</h1>
            {objectValidation(launchTestData) && (
              <h3 className="test-instruction-intro3">
                {launchTestData.data[0].intro3}
              </h3>
            )}
          </>
        )}
        <div className="test-instruction-contents">
          {getTestInst(questions).map((instData, index) => (
            <div key={index} className="test-instruction-content">
              <div className="test-instruction-img">
                <img src={instData.img} alt="" />
                {/* <LazyLoadImage
                  placeholderSrc={placeholderIcon}
                  alt=""
                  effect="blur"
                  src={instData.img}
                /> */}
              </div>
              <p>{instData.title}</p>
            </div>
          ))}
        </div>
        {objectValidation(launchTestData) && (
          <>
            <div className="instructions">
              <div className="instruction-do">
                {loader ? (
                  <Skeleton active />
                ) : (
                  <>
                    <h2 className="do-this">DO'S</h2>
                    <h1
                      dangerouslySetInnerHTML={{
                        __html: launchTestData.data[0].intro1,
                      }}
                    ></h1>
                  </>
                )}
              </div>
              <div className="instruction-do-not">
                {loader ? (
                  <Skeleton active />
                ) : (
                  <>
                    <h2 className="dont-do-this">DON'TS</h2>
                    <h1
                      dangerouslySetInnerHTML={{
                        __html: launchTestData.data[0].intro2,
                      }}
                    ></h1>
                  </>
                )}
              </div>
            </div>
            <div className="instruction-btn">
              {btnName1 && (
                <button className="custom-btn inst one" onClick={handleBtn1}>
                  {btnName1}
                  <img src={rightArrowIcon} alt="" />
                </button>
              )}
              {btnName2 && (
                <button className="custom-btn inst" onClick={handleBtn2}>
                  {btnName2}
                  <img src={rightArrowIcon} alt="" />
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
